import { TextField, styled } from '@mui/material';

export const TextField2 = styled(TextField)(({ theme }) => ({
  '& .MuiOutlinedInput-root': {
    '&.Mui-focused input': {
      borderColor: '#ffffff',
      backgroundColor: '#ffffff',
    },
  },
  justifySelf: 'start',
}));
